import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZakaznickaKategorie = {
	name: NAME,
	apiProvider,
	router,
};
